// extracted by mini-css-extract-plugin
export var container = "_h1-1";
export var cornerButtonContainer = "_h1-6";
export var disabled = "_h1-2";
export var dragActive = "_h1-3";
export var fileContainer = "_h1-5";
export var hiddenInput = "_h1-4";
export var widthContainer = "_h1-0";